import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../../Components/Table";
import { ListarCategoriasDeAtendimentoPorCasoController } from "../../../../Controllers/Geral/CategoriaAtendimento/CategoriaAtendimentoController";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { CategoriaAtendimentoPorCaso } from "../../../../Interfaces/Geral/GestaoDeCadastro/CategoriaAtendimento/CategoriaAtendimentoInterface";

interface ICategoriaAtendimentoCasoProps {
    idCaso: number;
}

export default function CategoriaAtendimentoCaso(
    props: ICategoriaAtendimentoCasoProps
) {
    const {
        value: categoriasAtendimento,
        loading: categoriasAtendimentoLoading,
    } = useAsyncEffect(
        () => ListarCategoriasDeAtendimentoPorCasoController(props.idCaso),
        [props.idCaso]
    );

    const tableviewColumns: Array<
        ColumnDescription<CategoriaAtendimentoPorCaso>
    > = [
        {
            dataField: "ID_CASO",
            text: "ID Caso",
        },
        {
            dataField: "DS_CATEGORIA_ATENDIMENTO_ABERTURA_COMP",
            text: "Categoria Atendimento Abertura",
        },
        {
            dataField: "DS_CATEGORIA_ATENDIMENTO_VISTORIA_COMP",
            text: "Categoria Atendimento Vistoria",
        },
        {
            dataField: "DS_CATEGORIA_ATENDIMENTO_REPARO_COMP",
            text: "Categoria Atendimento Reparo",
        },
        {
            dataField: "DS_CATEGORIA_ATENDIMENTO_FECHAMENTO_COMP",
            text: "Categoria Atendimento Fechamento",
        },
    ];

    return (
        <div className="card card-custom">
            <Table
                columns={tableviewColumns}
                data={categoriasAtendimento ?? []}
                keyField="ID_CASO"
                loading={categoriasAtendimentoLoading}
                noDataIndication={() => (
                    <div className="text-black-50 text-center">
                        Nenhuma categoria de atendimento encontrada
                    </div>
                )}
                noHover
                noSearch
                bordered={false}
                defaultStyle={{
                    align: "center",
                    classes: "p-2",
                }}
                striped={true}
                rowClasses={"rowClasses"}
            />
        </div>
    );
}
